export default "__VITE_ASSET__ot_1N2Zm__"